import { filterConfig } from 'view/acompanhamento/acompanhamento-condicao-saude/components/filter/model-acompanhamentoCondicaoSaudeFilter'
import { AcompanhamentoExpandableFilterContainer } from 'view/acompanhamento/components/AcompanhamentoExpandableFilterContainer'
import { AcompanhamentoFilterList } from 'view/acompanhamento/components/AcompanhamentoFilterList'

import { AcompanhamentoCondicaoSaudeFormModel } from '../../model/model-acompanhamentoCondicaoSaude'

interface AcompanhamentoCondicaoSaudeActiveFiltersProps {
  filtro: AcompanhamentoCondicaoSaudeFormModel
}

export function AcompanhamentoCondicaoSaudeActiveFilters({
  filtro,
}: Readonly<AcompanhamentoCondicaoSaudeActiveFiltersProps>) {
  return (
    <AcompanhamentoExpandableFilterContainer resetDependency={filtro}>
      <AcompanhamentoFilterList filtro={filtro} config={filterConfig} />
    </AcompanhamentoExpandableFilterContainer>
  )
}
